<template>
    <form :action="submitUrl" method="POST" role="form" class="form-horizontal throttle">
        <input type="hidden" name="_token" :value="csrfToken">
        <div class="form-group row">
            <label for="name" class="col-md-3 col-form-label text-right">Name</label>
            <div class="col-md-9">
                <input type="text" name="name" class="form-control">
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-9 ml-auto">
                <button class="btn btn-primary" type="submit">
                    Create
                </button>
                <button type="button" class="btn btn-secondary" data-toggle="collapse" data-target="#create_record">
                    Cancel
                </button>
            </div>
        </div>
    </form>
</template>
<script type="text/javascript">
    export default {
        name: 'category-form',
        props: [
            'submitUrl',
            'csrfToken'
        ]
    }
</script>
